<template>
    <div class="details-container">
      <div class="details-header">
          <div class="details-header-left" @click="handleBack">
            <img src="/assets/~/media/images/ai/left-arrow-white-icon.png" alt="">
            <div>返回</div>
          </div>
          <div class="details-header-middle">
            {{ typeText }}
          </div>
          <div style="width: 36px;"></div>
      </div> 
      <div class="details-grid-wrapper">
        <div class="card-grid">
          <div class="card-item" v-for="(item, index) in displayList" :key="index" @click="openLink(item.url)">
            <div>
              <!-- <div class="card-time" style="opacity: 0;">{{ item.createTime }}</div>  -->
              <div class="card-title" :title="item.title">{{ item.title }}</div>
            </div>
            <div class="card-action">查看</div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'moreCard',
    props: {
      typeText: {
        type: String,
        default: ''
      },
      newsList: {
        type: Array,
        default: () => []
      },
      activityList: {
        type: Array,
        default: () => []
      },
      type: {// activity: 相关活动, zixun: 相关资讯
        type: String,
        default: ''
      }
    },
    components: {},
    data() {
      return {
        
      }
    },
    computed: {
      displayList() {
        if (this.type === 'activity') {
          return this.activityList;
        } else if (this.type === 'zixun') {
          return this.newsList;
        }
        return this.newsList; // 默认返回 newsList
      }
    },
    mounted() {
      
    },
    watch: {

    },
    methods: {
        handleBack() {
          _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '活动/资讯-更多-返回', 1]);
          stm_clicki("send",'event',window.location.href, "点击", '活动/资讯-更多-返回');
            this.$emit('back');
        },
        openLink(url) {
          _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '活动/资讯-更多-跳转链接'+url, 1]);
          stm_clicki("send",'event',window.location.href, "点击", '活动/资讯-更多-跳转链接'+url);
          if (!url) return;
          window.open(url, '_blank');
        }
    },
}
  </script>
  
  <style lang="scss" scoped>
    .details-container {
      width: 100%;
      height: 100%;
      //   padding: calc(20 / 1080 * 100vh) calc(20 / 1920 * 100vw);
      background-color: rgba(6, 20, 31, 1);
    }
    
    
    
    .details-header {
        // height: calc(80 / 1920 * 100vw);
        height: 57px;
        display: flex;
        align-items: center; 
        justify-content: space-between;
        padding: 0 calc(35 / 1920 * 100vw);
        background-color: rgba(6, 20, 31, 1);
        
        .details-header-left {
            display: flex;
            align-items: center;
            // gap: calc(10 / 1920 * 100vw);
            gap: 5px;
            cursor: pointer;
            img {
                // width: calc(20 / 1920 * 100vw);
                // height: calc(20 / 1920 * 100vw);
                width: 18px;
                height: 18px;
            }
            div {
                font-size: 13px;
                color: #fff;
                font-family: 'FZLanTingHeiS-R-GB'; 
                line-height: 1;
            }
        }
        .details-header-middle {
            // font-size: calc(22 / 1920 * 100vw);
            font-size: 15px;
            color: #fff;
            font-family: 'FZLanTingHeiS-B-GB'; 
            line-height: 1;
        }
   }
    .details-grid-wrapper {
        padding: calc(40 / 1920 * 100vw) calc(40 / 1920 * 100vw);
        border-radius: calc(12 / 1920 * 100vw) calc(12 / 1920 * 100vw) 0 0;
        overflow: auto;
        background-color: #fff;
        // height: calc(100% -  80 / 1920 * 100vw);
        height: calc(100% -  57px);
        .card-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: calc(16 / 1920 * 100vw);
        }
        .card-item {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          aspect-ratio: 393 / 138;
          padding: calc(35 / 1920 * 100vw);
          border-radius: calc(8 / 1920 * 100vw);
          background-color: rgba(243, 245, 247, 1);
          cursor: pointer;
          transition: background-color 0.2s ease;
          overflow: hidden;
        }
        .card-item:hover {
          background-color: rgba(225, 229, 234, 1);
        }
        .card-time {
          font-size: calc(14 / 1920 * 100vw);
          color: rgba(6, 20, 31, 1);
          margin-bottom: calc(12 / 1920 * 100vw);
          font-family: 'FZLanTingHeiS-R-GB';
          
        }
        .card-title {
          font-size: calc(18 / 1920 * 100vw);
          color: rgba(6, 20, 31, 1);
          line-height: 1.4;
          margin-bottom: calc(10 / 1920 * 100vw);
          font-family: 'FZLanTingHeiS-DB-GB';
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .card-action {
          align-self: flex-start;
          font-size: calc(12 / 1920 * 100vw);
          color: rgba(6, 20, 31, 1);
          font-family: 'FZLanTingHeiS-R-GB';
        }
        /* 自定义滚动条样式 */
        &::-webkit-scrollbar {
        width: 4px;
        }
        
        &::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.05);
        border-radius: 3px;
        }
        
        &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.2);
        border-radius: 3px; 
        transition: background 0.3s ease;
        
        &:hover {
            background: rgba(0, 0, 0, 0.4);
        }
        }
        
        /* Firefox 滚动条样式 */
        scrollbar-width: thin;
        scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);

   }
   
   
  </style>
  